import type { Object3D } from 'three';
import {
  parseElbowPlacementMarker,
  withElbowPlacementMarker,
  type ElbowPlacementMarker,
} from '@harryhausen/kernel';
import { boneOfSelectedSkeleton } from './convert-rig.js';
type Selection = { label: string; selectSkeleton?: string };
export function readSceneElbowPlacement(root: Object3D, bone: string, options: Selection) {
  const node = boneOfSelectedSkeleton(root, bone, options);
  if (!node) throw new Error(`No elbow marker node ${bone} in ${options.label}`);
  return parseElbowPlacementMarker(node.userData, `${bone} in ${options.label}`);
}
export function writeSceneElbowPlacement(
  root: Object3D,
  bone: string,
  marker: ElbowPlacementMarker,
  options: Selection,
) {
  const node = boneOfSelectedSkeleton(root, bone, options);
  if (!node) throw new Error(`No elbow marker node ${bone} in ${options.label}`);
  node.userData = withElbowPlacementMarker(node.userData, marker);
}
